<template>
  <div class="main_wrap">
    <Navigator :routeList="navigate" />
    <main>
      <div class="title">系统消息</div>
      <template v-if="msgList.length">
        <div class="content">
          <div class="msg-list">
            <div class="msg-item" v-for="(item, index) in msgList" :key="index">
              <el-badge is-dot :hidden="item.readStatus ? true : false">
                <el-image
                  class="msg-icon"
                  :src="require(`@/assets/icons/icon_message.png`)"
                  fit="cover"
                ></el-image>
              </el-badge>
              <div class="msg-content">
                <div class="msg-header">
                  <div class="msg-title">
                    <div class="msg-type">{{ item.title }}</div>
                    <div class="msg-time">{{ item.createTime }}</div>
                  </div>
                </div>
                <div class="msg-text">
                  <template v-if="item.bizContent.content.length > 60">
                    {{ item.bizContent.content.slice(0, 60) }}······
                  </template>
                  <template v-else>
                    {{ item.bizContent.content }}
                  </template>
                  <!-- 这是可以查看详情的 转校通知 -->
                  <template
                    v-if="
                      item.bizType == 6 &&
                      item.bizTypeParams &&
                      item.bizTypeParams.id
                    "
                  >
                    <span
                      class="msg-result"
                      @click="
                        jumpToDetail(
                          item.id,
                          item.bizTypeParams.id,
                          item.bizType
                        )
                      "
                    >
                      查看审核结果>>
                    </span>
                  </template>
                  <!-- 这是非转校通知，但是内容未确定，等待新增 -->
                  <template v-else> </template>
                </div>
              </div>
            </div>
          </div>
          <el-pagination
            background
            class="page_nav"
            layout="prev, pager, next"
            :page-size="8"
            v-if="total > 8"
            @current-change="pageChange"
            :current-page="pageNo"
            :total="total"
          >
          </el-pagination>
        </div>
      </template>
      <template v-else>
        <el-empty
          :image="require('@/assets/images/collectionEmpty.png')"
          description="暂无系统通知"
        ></el-empty>
      </template>
    </main>
  </div>
</template>

<script>
import Navigator from "@/components/navigate.vue";
import { getMessageList } from "@/api/user";

export default {
  name: "messageCenter",
  components: { Navigator },
  data() {
    //这里存放数据
    return {
      navigate: [
        { name: "首页", url: "/course" },
        { name: "消息中心", isCurrent: true },
      ],
      msgList: [],
      total: 0,
      pageNo: 1,
    };
  },
  methods: {
    initData() {
      this.getMessageList();
    },
    getMessageList() {
      //参数1为获取系统通知类型、参数2为分页页数，参数3为每页获取的个数
      getMessageList(this.pageNo, 8).then((res) => {
        this.msgList = res.records;
        this.total = parseInt(res.total);
      });
    },
    pageChange(ev) {
      this.pageNo = ev;
      this.getMessageList();
    },
    jumpToDetail(id, paramsId, bizType) {
      this.$router.push(
        `/personal/messageDetail?id=${id}&paramsId=${paramsId}&bizType=${bizType}`
      );
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
<style lang='scss' scoped>
.main_wrap {
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  main {
    width: 90%;
    box-sizing: border-box;
    margin: 0 auto;
    padding: 4rem 10rem;

    .title {
      font-size: 2rem;
      width: 100%;
      height: fit-content;
      font-weight: 700;
      box-sizing: border-box;
      padding-bottom: 2.5rem;
      border-bottom: 1px solid #ebeded;
    }

    .content {
      width: 100%;
      margin-top: 3rem;
      box-sizing: border-box;

      .msg-list {
        box-sizing: border-box;
        min-height: 50rem;
        .msg-item {
          display: flex;
          margin-bottom: 4.5rem;
          max-width: 80%;
          .msg-icon {
            width: 5.2rem;
            height: 5.2rem;
          }
          .msg-content {
            display: flex;
            flex-direction: column;
            box-sizing: border-box;
            border-radius: 1rem;
            margin-left: 2rem;
            width: 100%;
            .msg-header {
              display: flex;
              align-items: flex-end;
              margin-bottom: 1rem;
              justify-content: space-between;
              .msg-title {
                display: flex;
                align-items: flex-end;
                .msg-type {
                  font-size: 2.2rem;
                  font-weight: bold;
                  color: #333333;
                }
                .msg-time {
                  margin-left: 1rem;
                  font-size: 1.8rem;
                  color: #999999;
                }
              }
            }
            .msg-text {
              color: #333333;
              font-size: 1.8rem;
              line-height: 3.5rem;
              .msg-result {
                color: $color-primary;
                cursor: pointer;
              }
            }
          }
        }
      }

      .page_nav {
        display: table;
        margin: 8rem auto 0;
      }
    }
  }
}
</style>